export default [
  {
    name: "0 ثانیه",
    value: 0,
  },
  {
    name: "0.5 ثانیه",
    value: 500,
  },
  {
    name: "1 ثانیه",
    value: 1000,
  },
  {
    name: "1.5 ثانیه",
    value: 1500,
  },
  {
    name: "2 ثانیه",
    value: 2000,
  },
  {
    name: "2.5 ثانیه",
    value: 2500,
  },
  {
    name: "3 ثانیه",
    value: 3000,
  },
  {
    name: "3.5 ثانیه",
    value: 3500,
  },
  {
    name: "4 ثانیه",
    value: 4000,
  },
  {
    name: "4.5 ثانیه",
    value: 4500,
  },
  {
    name: "5 ثانیه",
    value: 5000,
  },
  {
    name: "5.5 ثانیه",
    value: 5500,
  },
  {
    name: "6 ثانیه",
    value: 6000,
  },
  {
    name: "6.5 ثانیه",
    value: 6500,
  },
  {
    name: "7 ثانیه",
    value: 7000,
  },
  {
    name: "7.5 ثانیه",
    value: 7500,
  },
  {
    name: "8 ثانیه",
    value: 8000,
  },
  {
    name: "8.5 ثانیه",
    value: 8500,
  },
  {
    name: "9 ثانیه",
    value: 9000,
  },
  {
    name: "9.5 ثانیه",
    value: 9500,
  },
  {
    name: "10 ثانیه",
    value: 10000,
  },
  {
    name: "10.5 ثانیه",
    value: 10500,
  },
  {
    name: "11 ثانیه",
    value: 11000,
  },
  {
    name: "11.5 ثانیه",
    value: 11500,
  },
  {
    name: "12 ثانیه",
    value: 12000,
  },
  {
    name: "12.5 ثانیه",
    value: 12500,
  },
  {
    name: "13 ثانیه",
    value: 13000,
  },
  {
    name: "13.5 ثانیه",
    value: 13500,
  },
  {
    name: "14 ثانیه",
    value: 14000,
  },
  {
    name: "14.5 ثانیه",
    value: 14500,
  },
  {
    name: "15 ثانیه",
    value: 15000,
  },
  {
    name: "15.5 ثانیه",
    value: 15500,
  },
  {
    name: "16 ثانیه",
    value: 16000,
  },
  {
    name: "16.5 ثانیه",
    value: 16500,
  },
  {
    name: "17 ثانیه",
    value: 17000,
  },
  {
    name: "17.5 ثانیه",
    value: 17500,
  },
  {
    name: "18 ثانیه",
    value: 18000,
  },
  {
    name: "18.5 ثانیه",
    value: 18500,
  },
  {
    name: "19 ثانیه",
    value: 19000,
  },
  {
    name: "19.5 ثانیه",
    value: 19500,
  },
  {
    name: "20 ثانیه",
    value: 20000,
  },
  {
    name: "21 ثانیه",
    value: 21000,
  },
  {
    name: "22 ثانیه",
    value: 22000,
  },
  {
    name: "23 ثانیه",
    value: 23000,
  },
  {
    name: "24 ثانیه",
    value: 24000,
  },
  {
    name: "25 ثانیه",
    value: 25000,
  },
  {
    name: "26 ثانیه",
    value: 26000,
  },
  {
    name: "27 ثانیه",
    value: 27000,
  },
  {
    name: "28 ثانیه",
    value: 28000,
  },
  {
    name: "29 ثانیه",
    value: 29000,
  },
  {
    name: "30 ثانیه",
    value: 30000,
  },
  {
    name: "31 ثانیه",
    value: 31000,
  },
  {
    name: "32 ثانیه",
    value: 32000,
  },
  {
    name: "33 ثانیه",
    value: 33000,
  },
  {
    name: "34 ثانیه",
    value: 34000,
  },
  {
    name: "35 ثانیه",
    value: 35000,
  },
  {
    name: "36 ثانیه",
    value: 36000,
  },
  {
    name: "37 ثانیه",
    value: 37000,
  },
  {
    name: "38 ثانیه",
    value: 38000,
  },
  {
    name: "39 ثانیه",
    value: 39000,
  },
  {
    name: "40 ثانیه",
    value: 40000,
  },
  {
    name: "41 ثانیه",
    value: 41000,
  },
  {
    name: "42 ثانیه",
    value: 42000,
  },
  {
    name: "43 ثانیه",
    value: 43000,
  },
  {
    name: "44 ثانیه",
    value: 44000,
  },
  {
    name: "45 ثانیه",
    value: 45000,
  },
  {
    name: "46 ثانیه",
    value: 46000,
  },
  {
    name: "47 ثانیه",
    value: 47000,
  },
  {
    name: "48 ثانیه",
    value: 48000,
  },
  {
    name: "49 ثانیه",
    value: 49000,
  },
  {
    name: "50 ثانیه",
    value: 50000,
  },
  {
    name: "51 ثانیه",
    value: 51000,
  },
  {
    name: "52 ثانیه",
    value: 52000,
  },
  {
    name: "53 ثانیه",
    value: 53000,
  },
  {
    name: "54 ثانیه",
    value: 54000,
  },
  {
    name: "55 ثانیه",
    value: 55000,
  },
  {
    name: "56 ثانیه",
    value: 56000,
  },
  {
    name: "57 ثانیه",
    value: 57000,
  },
  {
    name: "58 ثانیه",
    value: 58000,
  },
  {
    name: "59 ثانیه",
    value: 59000,
  },
  {
    name: "1 دقیقه",
    value: 60000,
  },
  {
    name: "2 دقیقه",
    value: 120000,
  },
  {
    name: "3 دقیقه",
    value: 180000,
  },
  {
    name: "4 دقیقه",
    value: 240000,
  },
  {
    name: "5 دقیقه",
    value: 300000,
  },
  {
    name: "10 دقیقه",
    value: 600000,
  },
  {
    name: "15 دقیقه",
    value: 900000,
  },
  {
    name: "20 دقیقه",
    value: 1200000,
  },
  {
    name: "30 دقیقه",
    value: 1800000,
  },
  {
    name: "40 دقیقه",
    value: 2400000,
  },
  {
    name: "50 دقیقه",
    value: 3000000,
  },
  {
    name: "1 ساعت",
    value: 3600000,
  },
];
